import React, {useEffect, useState} from "react"
import Link from "../../../../../UI/Link/Link"
import PropTypes from "prop-types"
import * as styles from "./NavigationItem-tw-styles"

const NavigationItem = props => {
  const { item, isActive, variant, language } = props
  const { label, link } = item
  const style = language=="en" ? styles[variant] : styles.defaultStyle
  const { navLink } = style	
  return (
    <li className={`nav-item uppercase`} >
      {link ? (
        <Link
          {...link}
          className={`${navLink} ${isActive} `}
          gaEventClass="event_menu_click"
          gaEventLabel={label}
          onClick={()=>alert('clicked')}
        >
          {label}
        </Link>
      ) : (
        label
      )}
    </li>
  )
}

NavigationItem.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.object,
  }),
  isActive: PropTypes.string,
  variant: PropTypes.string,
  language: PropTypes.string,
}

export default NavigationItem
